import styles from "./withdraw.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { IoSearch, IoCopyOutline } from "react-icons/io5";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import moment from "moment";
import Loader from "../../components/loader";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import "./pagination.css";
export default function Withdraw() {
  const navigate = useNavigate();
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [selectArray, setSelectArray] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [parameter, setParameter] = useState({
    fromDate: "",
    toDate: "",
    search: "",
    status: "",
    limit: 20,
  });
  const [loading, setLoading] = useState(false);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };
  const getAssetWithdrawlisthandle = useCallback(async () => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.getAssetWithdrawlist}?page=${currentPage}&search=${parameter?.search}&fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}&status=${parameter?.status}&limit=${parameter.limit}`,
        { headers }
      );
      setLoading(false);
      setData(res?.data?.result);
      setTotalPages(res?.data?.result.metadata[0].total_page);
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
      if (error?.response?.data?.statusCode === 400) {
        localStorage.clear();
        navigate("/login");
      }
    }
  }, [currentPage, navigate, parameter, userToken]);
  useEffect(() => {
    getAssetWithdrawlisthandle();
  }, [getAssetWithdrawlisthandle]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const old = data?.data.map((n) => n._id);
      setSelectArray(old);
      return;
    }
    setSelectArray([]);
  };
  const handleWithdrwApprove = async (status) => {
    try {
      setLoading(true);
      setButtonLoading(true);
      const headers = {
        token: userToken,
      };
      const data = {
        action: status,
        objectId: selectArray,
      };
      await axios.post(`${apiConfig.approveWithdrawReq}`, data, {
        headers,
      });
      setSelectArray([]);
      getAssetWithdrawlisthandle();
      setLoading(false);
      setButtonLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setButtonLoading(false);
    }
  };

  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Withdraw Management</h1>
      {/* <div className={styles.balanceBox}>
        <div className={styles.balanceItem}>
          <span>Gas Fee:</span> <strong>{bnbBalance} BNB</strong>
          <span>BNB Wallet Add:</span>
          {WALLET_ADDRESS}
        </div>

        <div className={styles.balanceItem}>
          <span>Hot Wallet Balance:</span> <strong>{usdtBalance} USDT</strong>
          <span>Hot Wallet Add:</span>
          {REACT_HOT_WALLET_ADDRESS}
        </div>

        <button className={styles.refreshButton} onClick={refreshBalance}>
          🔄 Refresh
        </button>
      </div> */}
      <div className={styles?.userTopContainer}>
        <div className={styles?.userTopBoxLeft}>
          <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
            <span>Search</span>
            <div className={styles.inputBoxChild}>
              <input
                type="text"
                placeholder="Search Email, NWithdraw Managementickname Or Referral ID"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, search: e.target.value });
                }}
                value={parameter?.search}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getAssetWithdrawlisthandle();
                  }
                }}
              />
              <IoSearch
                className={styles.inputSearchIcon}
                onClick={getAssetWithdrawlisthandle}
              />
            </div>
          </div>
          <div className={styles.selectBox}>
            <span>Status</span>
            <div className={styles.selectBoxChild}>
              <select
                className={styles.selectMain}
                onChange={(e) => {
                  setParameter({
                    ...parameter,
                    status: e.target.value,
                  });
                }}
                value={parameter?.planSubscription}
              >
                <option className={styles.optionMain} value={"ALL"}>
                  All
                </option>
                <option className={styles.optionMain} value={"COMPLETED"}>
                  Approved
                </option>
                <option className={styles.optionMain} value={"CANCELLED"}>
                  Rejected
                </option>
                <option
                  className={styles.optionMain}
                  value={"WAITING_APPROVAL"}
                >
                  Waiting Approval
                </option>
              </select>
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>From</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, fromDate: e.target.value });
                }}
                value={parameter?.fromDate}
              />
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>To</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, toDate: e.target.value });
                }}
                value={parameter?.toDate}
              />
            </div>
          </div>
          <div className={styles.userTopBoxRight}>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                setParameter({
                  fromDate: "",
                  toDate: "",
                  search: "",
                  status: "ALL",
                  limit: 20,
                });
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      {selectArray.length > 0 && (
        <>
          <div className={styles.userAddContainer}>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                handleWithdrwApprove("APPROVE");
              }}
              disabled={buttonLoading}
            >
              {buttonLoading ? "Loaing..." : "Bulk Approve"}
            </button>

            <button
              className={styles.downloadBtn}
              onClick={() => {
                handleWithdrwApprove("REJECT");
              }}
              disabled={buttonLoading}
            >
              {buttonLoading ? "Loaing..." : "Bulk Reject"}
            </button>
          </div>
        </>
      )}
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            placeContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader width={"100px"} height={"100px"} />
        </div>
      ) : (
        <>
          {!data || data?.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "bold",
              }}
            >
              No Data Found
            </p>
          ) : (
            <div className={styles.tableWrallerUser}>
              <table>
                <tr>
                  <th className={styles.flexTableData}>
                    <input
                      type="checkbox"
                      className={styles.checkInputTable}
                      onClick={handleSelectAllClick}
                    />
                    No.
                  </th>
                  <th>Transaction Id</th>
                  <th>Username</th>
                  <th>Full Name</th>
                  <th>Mode</th>
                  <th>To Wallet</th>
                  <th>Wallet Balance</th>
                  <th>Amount</th>
                  <th>Transaction Fees</th>
                  <th>Arrival Amount</th>
                  <th>Date & Time</th>
                  <th>Status</th>
                </tr>
                {data?.data?.map((item, index) => {
                  return (
                    <tr>
                      <td className={styles.flexTableData}>
                        <input
                          type="checkbox"
                          className={styles?.checkInputTable}
                          checked={selectArray.some((n) => n === item?._id)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setSelectArray([...selectArray, item?._id]);
                              return;
                            }
                            setSelectArray(
                              selectArray.filter((n) => n !== item?._id)
                            );
                          }}
                        />
                        {index + 1 + (currentPage - 1) * parameter?.limit}
                      </td>
                      <td>
                        {item?.transactionId}{" "}
                        <IoCopyOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(item?.transactionId);
                          }}
                        />
                      </td>
                      <td>
                        {item?.userName}{" "}
                        <IoCopyOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(item?.userName);
                          }}
                        />
                      </td>
                      <td>
                        {item?.firstName
                          ? item.firstName +
                            " " +
                            (item.lastName ? item.lastName : "NA")
                          : "NA"}
                      </td>
                      <td>{item?.mode} </td>
                      <td>
                        {item?.toWalletAddress}
                        <IoCopyOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              item?.toWalletAddress
                            );
                          }}
                        />
                      </td>
                      <td>
                        {item?.walletBalance}{" "}
                        <IoCopyOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(item?.walletBalance);
                          }}
                        />
                      </td>
                      <td>{item?.amount + item?.transactionFee}</td>
                      <td>
                        {item?.transactionFee
                          ? item.transactionFee.toFixed(2)
                          : "N/A"}
                      </td>
                      <td>{item?.amount.toFixed(4)}</td>
                      <td>
                        {moment(item?.createdAt).format("DD-MM-YY | HH:mm:ss")}
                      </td>
                      <td>{item?.transacionStatus}</td>
                    </tr>
                  );
                })}
              </table>
            </div>
          )}
          {(data || !data.length === 0) && (
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
              breakClassName={"ellipsis"}
              pageClassName={"page-item"}
              previousClassName={"previous"}
              nextClassName={"next"}
              forcePage={currentPage - 1}
            />
          )}
        </>
      )}
    </div>
  );
}
